import { CheckCircle2, Circle, XCircle } from "lucide-react";
import { formatRelativeTime, formatDuration } from "@/lib/format";

const STATUS_COLOR = {
    booked: "text-zinc-600 dark:text-zinc-400",
    in_progress: "text-sky-600 dark:text-sky-400",
    awaiting_approval: "text-violet-600 dark:text-violet-400",
    awaiting_parts: "text-blue-600 dark:text-blue-400",  // info: parts not in stock
    qc: "text-blue-600 dark:text-blue-400",
    ready: "text-emerald-600 dark:text-emerald-400",
    delivered: "text-emerald-700 dark:text-emerald-300",
    cancelled: "text-rose-600 dark:text-rose-400",
};

const TERMINAL = new Set(["delivered", "cancelled"]);

export function StageTimeline({ stages = [], durations = {}, className = "" }) {
    if (!stages.length) {
        return (
            <div className={`rounded-md border border-dashed border-zinc-300 p-4 text-center text-sm text-zinc-500 dark:border-zinc-700 ${className}`}>
                No stage history yet.
            </div>
        );
    }
    return (
        <ol className={`relative space-y-3 border-l border-zinc-200 pl-5 dark:border-zinc-800 ${className}`} data-testid="stage-timeline">
            {stages.map((s, i) => {
                const isLast = i === stages.length - 1;
                const Icon = s.to === "cancelled" ? XCircle : isLast && !TERMINAL.has(s.to) ? Circle : CheckCircle2;
                const color = STATUS_COLOR[s.to] || "text-zinc-500";
                const dur = durations[s.from];
                return (
                    <li key={i} className="relative">
                        <span className={`absolute -left-[27px] grid h-5 w-5 place-items-center rounded-full bg-background ${color}`}>
                            <Icon className="h-4 w-4" />
                        </span>
                        <div className="text-sm">
                            <span className="font-semibold capitalize">{(s.to || "").replace(/_/g, " ")}</span>
                            {s.from && (
                                <span className="ml-1 text-xs text-zinc-500">
                                    from <span className="capitalize">{s.from.replace(/_/g, " ")}</span>
                                    {dur ? <span className="ml-1 font-mono">· {formatDuration(dur)}</span> : null}
                                </span>
                            )}
                            <div className="text-xs text-zinc-500">
                                {formatRelativeTime(s.at)}
                                {s.notes ? <span className="ml-2 italic">· {s.notes}</span> : null}
                            </div>
                        </div>
                    </li>
                );
            })}
        </ol>
    );
}
